module.exports = __webpack_public_path__ + "img/warning-icon.d2f4c4ae.svg";